import React, { FC } from 'react';
import { GxButton, GxIcon } from '@garpix/garpix-web-components-react';
import 'react-responsive-modal/styles.css';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import { MailIcon, TaskIcon } from '../../../../../assets';
import { formattingPhoneNumber } from '../../../../../utils';
import styles from '../styles/index.module.scss';
import ModalCreateTask from '../../ModalCreateTask';
import ModalSendMessage from '../../ModalSendMessage';
import useModalFlag from '../../../../../hooks/useModalFlag';
import { IUser } from '../../../../../types';
import { TYPE_MODAL_TASK } from '../../ModalCreateTask/const';
import { TYPE_USER } from '../../../../../const';

interface IModalUserHeader {
  isEdit: boolean;
  userData?: IUser;
}

const ModalUserHeader: FC<IModalUserHeader> = ({ isEdit, userData }) => {
  const { flag: FlagFirst, setModalFlag: setModalFlagFirst } = useModalFlag();
  const { flag: FlagSecond, setModalFlag: setModalFlagSecond } = useModalFlag();
  const { currentUser } = useStoreon<State, Events>('currentUser');

  return (
    <>
      <div className={styles['header']}>
        <div className={styles['header--container']}>
          <div className={styles['header-user']}>
            <p className={styles['header-user--name']}>
              {isEdit
                ? `${userData?.first_name} ${userData?.last_name}`
                : 'Новый пользователь'}
            </p>
            {userData?.phone && (
              <p className={styles['header-user--phone']}>
                {formattingPhoneNumber(userData?.phone)}
              </p>
            )}
          </div>
          {currentUser.user_status !== TYPE_USER.VIEWER && (
            <div className={styles['header-actions']}>
              <GxButton
                className={styles['header-actions--btn']}
                onClick={setModalFlagFirst}
              >
                <GxIcon
                  className={styles['header-actions--icon']}
                  src={TaskIcon}
                />
                Поставить задачу
              </GxButton>
              <GxButton
                className={styles['header-actions--btn']}
                onClick={setModalFlagSecond}
              >
                <GxIcon
                  className={styles['header-actions--icon']}
                  src={MailIcon}
                />
                Отправить сообщение
              </GxButton>
            </div>
          )}
        </div>
      </div>
      {FlagFirst && (
        <ModalCreateTask
          props={{ typeModal: TYPE_MODAL_TASK.USER, user: userData }}
          flag={FlagFirst}
          onRequestClose={setModalFlagFirst}
        />
      )}
      {FlagSecond && (
        <ModalSendMessage
          user={userData}
          flag={FlagSecond}
          onRequestClose={setModalFlagSecond}
        />
      )}
    </>
  );
};

export default ModalUserHeader;
